
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MarkUpPolicyDialog extends Serenity.EntityDialog<MarkUpPolicyRow, any> {
        protected getFormKey() { return MarkUpPolicyForm.formKey; }
        protected getIdProperty() { return MarkUpPolicyRow.idProperty; }
        protected getLocalTextPrefix() { return MarkUpPolicyRow.localTextPrefix; }
        protected getNameProperty() { return MarkUpPolicyRow.nameProperty; }
        protected getService() { return MarkUpPolicyService.baseUrl; }
        protected getDeletePermission() { return MarkUpPolicyRow.deletePermission; }
        protected getInsertPermission() { return MarkUpPolicyRow.insertPermission; }
        protected getUpdatePermission() { return MarkUpPolicyRow.updatePermission; }

        protected form = new MarkUpPolicyForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.Charges);
        }
        protected updateInterface() {
            super.updateInterface();
            this.cloneButton.toggle(this.isEditMode());
            //this.setReadOnly(this.isViewMode()); 
        }
        protected getCloningEntity() {
            var clone = super.getCloningEntity();

            // add (Clone) suffix if it's not already added
            //var suffix = ' (Clone)';
            //if (!Q.endsWith(clone.MarkUpPolicyCode || '', suffix)) {
            //    clone.MarkUpPolicyCode = (clone.MarkUpPolicyCode || '') + suffix;
            //}
            clone.MarkUpPolicyCode = null;
            //this.dialogClose();
            // let's clear fields not logical to be cloned 
            return clone;
        }
    }
}